import {useQuery} from "react-query";
import OnTimeDepartureApi from "./OnTimeDeparture.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useOnTimeDeparture(query:IWidgetQuery){
    return useQuery(["fetchOnTimeDeparture", query], OnTimeDepartureApi.getData);
}